import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";

import {
  authModalHandler,
  changeModal,
  deleteAccount,
  postStudioName,
} from "../../store/slices/Preference/studioDetailstSlice";
import { useLogout } from "../Header/useLogout";

export const useStudioDetails = () => {
  const dispatch = useDispatch();
  const { userProfileData } = useSelector((state) => state.userData);
  const [showChangeLogoModal, setShowChangeLogoModal] = useState({});
  const [openWaterMark, setOpenWaterMark] = useState(false);
  const [stepsData, setStepsData] = useState([
    {
      id: 1,
      title: "Upload your logo",
      description: "You can upload .JPEG and .PNG files of maximum 2 MB size.",
      icon_name: "icon-upload",
      type: "logo",
      img: "",
    },
    {
      id: 1,
      title: "Upload your watermark here",
      description: ".PNG files up to a maximum of 2 MB",
      icon_name: "icon-watermark",
      type: "waterMark",
      img: "",
    },
  ]);

  const [showChangeProfilePictureModal, setShowChangeProfilePictureModal] =
    useState(false);
  const [showChangeWatermarkModal, setShowChangeWatermarkModal] =
    useState(false);
  const [openEditStudioModal, setOpenEditStudioModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openMobileModal, setOpenMobileModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { handleLogout } = useLogout();

  useEffect(() => {
    if (userProfileData?.logo_url || userProfileData?.water_mark_url) {
      let newdata = [...stepsData];
      newdata[0].img = userProfileData?.logo_url;
      newdata[1].img = userProfileData?.water_mark_url;
      setStepsData(newdata);
    }
  }, [userProfileData]);

  const handleCloseModal = () => {
    setShowChangeLogoModal({
      ...showChangeLogoModal,
      isOpen: false,
    });
  };

  const handleCloseModalWaterMark = () => {
    setOpenWaterMark(false);
  };

  const nameValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
  });

  const nameSubmit = async (FormData, resetForm) => {
    const resultAction = await dispatch(postStudioName(FormData));
    if (postStudioName.fulfilled.match(resultAction)) {
      resetForm();
      dispatch(authModalHandler(false));
      toast.success("Success", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleClick = (type) => {
    if (type == "name") {
      dispatch(changeModal("name"));
      dispatch(authModalHandler(true));
    } else if (type == "email") {
      dispatch(changeModal("email"));
      dispatch(authModalHandler(true));
    } else if (type == "mobile") {
      dispatch(changeModal("mobile"));
      dispatch(authModalHandler(true));
    } else if (type == "change logo") {
      dispatch(changeModal("change logo"));
      if (type == "change logo") {
        let data = {
          title: "Upload logo",
          isOpen: true,
          type: "logo",
        };
        setShowChangeLogoModal(data);
      }
    } else if (type == "waterMark") {
      dispatch(changeModal("waterMark"));
      setOpenWaterMark(true);
      // if (type == "waterMark") {
      //   let data = {
      //     title: "Change water mark",
      //     isOpen: true,
      //     type: "waterMark",
      //   };
      //   setShowChangeLogoModal(data);
      // }
    } else if (type == "deletAccount") {
      dispatch(changeModal("deletAccount"));
      dispatch(authModalHandler(true));
    } else if (type == "socialMedia") {
      dispatch(changeModal("socialMedia"));
      dispatch(authModalHandler(true));
    } else if (type == "address") {
      dispatch(changeModal("address"));
      dispatch(authModalHandler(true));
    }
  };

  const deletAccount = async () => {
    const resultAction = await dispatch(deleteAccount());
    if (deleteAccount.fulfilled.match(resultAction)) {
      dispatch(authModalHandler(false));
      handleLogout();
    }
  };

  return {
    stepsData,
    showChangeProfilePictureModal,
    showChangeWatermarkModal,
    openEditStudioModal,
    showChangeLogoModal,
    openEmailModal,
    openMobileModal,
    openDeleteModal,
    nameValidationSchema,
    openWaterMark,
    setShowChangeLogoModal,
    handleCloseModalWaterMark,
    setShowChangeProfilePictureModal,
    setShowChangeWatermarkModal,
    setOpenEditStudioModal,
    setOpenEmailModal,
    setOpenMobileModal,
    setOpenDeleteModal,
    handleClick,
    nameSubmit,
    deletAccount,
    setStepsData,
    handleCloseModal,
  };
};
